import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AiResponderSettingsComponent } from './settings/ai-responder-settings.component'
import { SharedModule } from '@tv3/shared/shared.module'
import { AIResponderSettingsService } from './settings/ai-responser-settings.service'
import { AiResponderWebsitesComponent } from './settings/websites/ai-responder-websites.component'
import { AiResponderFaqComponent } from './settings/faq/ai-responder-faq.component'
import { EditorModule } from '@tinymce/tinymce-angular'
import { AiResponderRentalDetailsComponent } from './settings/rental-details/ai-responder-rental-details.component'
import { AiResponderIgnoreListComponent } from './settings/ignore-list/ai-responder-ignore-list.component'
import { AISettingsStoreModule } from '@tv3/containers/ai-responder/store/ai-settings.module'
import { AiAutoCreditRechargeComponent } from '@tv3/containers/ai-responder/settings/auto-credit-recharge/ai-auto-credit-recharge.component'
import { SignatureLibraryModule } from '@tokeet-frontend/signature'
import { CreditChargeStoreModule } from '@tokeet-frontend/billing'
import { AiResponderIncidentTaskComponent } from './settings/incident-task/ai-responder-incident-task.component'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { AiIncidentNotificationComponent } from './settings/incident-task/ai-incident-notification/ai-incident-notification.component'
import { AiOffCalendarComponent } from './settings/ai-off-calendar/ai-off-calendar.component'
import { AiOffCalendarCellComponent } from './settings/ai-off-calendar/ai-off-calendar-cell/ai-off-calendar-cell.component'
import { CalendarListModule } from '@tokeet/ngx-calendar-list'
import { ScheduleAiOffDialogComponent } from './settings/ai-off-calendar/schedule-ai-off-dialog/schedule-ai-off-dialog.component'

import { AiResponderSharedModule } from './ai-responder-shared.module'

const components = [
  AiResponderWebsitesComponent,
  AiResponderFaqComponent,
  AiResponderSettingsComponent,
  AiResponderRentalDetailsComponent,
  AiResponderIgnoreListComponent,
  AiResponderIncidentTaskComponent,
  AiIncidentNotificationComponent,
  AiAutoCreditRechargeComponent,
  AiOffCalendarComponent,
  AiOffCalendarCellComponent,
  ScheduleAiOffDialogComponent,
]

const modules = [
  SharedModule,
  AiResponderSharedModule,
  MatSlideToggleModule,
  EditorModule,
  AISettingsStoreModule,
  SignatureLibraryModule,
  CreditChargeStoreModule,
  CalendarListModule,
]

@NgModule({
  declarations: [...components],
  exports: [...components, ...modules],
  imports: [CommonModule, ...modules],
  providers: [AIResponderSettingsService],
})
export class AiResponderModule {}
